import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    templateUrl: './tos.component.html',
    styleUrls: ['./tos.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TosComponent {
    constructor() {}
}
